import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import withModal from '../../../commons/hocModal';

import VisualMode from './VisualMode';
import SelectorDropDown from '../../../commonComponents/SelectorDropDown';

import { translate } from '../../../commons/localize';
import { getContractListItemByReservation, getOptionsFromContractsList } from './uitls';
import { componentPropTypes, componentDefaultProps } from './propTypes';
import { mapStateToProps, mapDispatchToProps } from './reducerConsts';

import './ContractForm.css';

const ContractForm = (props) => {
  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    const { reservationData, contractsList } = props;
    const { contract } = reservationData;

    if (!contract) {
      const filteredContract = getContractListItemByReservation(props.reservationData, contractsList);

      if(!filteredContract) return;

      handleDetailContract(filteredContract, false);
      return;
    }

    setDefaultValue(contract.id);
  }, [props.contractsList, props.reservationData.contract]); // eslint-disable-line react-hooks/exhaustive-deps

  const {
    reservationData,
    readOnly,
    contractsList,
    contractDetailList
  } = props;

  const loadAndSetDetailContract = (reservationId, contractData, markAsModification) => {
    const {
      hotelCode,
      tourOperator,
      loadFullContractData
    } = props;

    loadFullContractData(
      reservationId,
      hotelCode,
      tourOperator,
      contractData,
      markAsModification,
      (errorMessage) => {
        props.handleModalMessages('errorModal', 'errorFullContract', errorMessage, 'entendido');
      }
    );

    setDefaultValue(contractData.id);
  };

  const handleDetailContract = (contractData, markAsModification) => {
    const { id } = props.reservationData;

    const filteredDetailContract = contractDetailList.find((contract) => contract.id === contractData.id);

    if(!filteredDetailContract) {
      loadAndSetDetailContract(id, contractData, markAsModification);
      return;
    }
    
    const reservationContract = {
      ...filteredDetailContract,
      period: contractData.period
    };

    props.updateReservationContract(id, contractData.rate.code, reservationContract, markAsModification);
    setDefaultValue(contractData.id);
  };

  const handleContractSelection = (selectedContractId) => {
    if (selectedContractId === '') return;

    const filteredContract = contractsList.find(contractData => (contractData.id === selectedContractId));

    if (!filteredContract) return;

    handleDetailContract(filteredContract, true);
  };

  const selectorValidation = (defaultValue !== undefined && defaultValue !== '');

  return (
    <>
      {(readOnly)
        ?
          <VisualMode
            title={translate('contrato')}
            rateCode={reservationData.rateCode}
          />
        :
          <SelectorDropDown
            title={translate('seleccionContrato')}
            dataTestLabel="selector-contrato"
            placeHolder={translate('placeHolderSelector')}
            options={getOptionsFromContractsList(contractsList)}
            defaultValue={defaultValue}
            isValid={selectorValidation}
            checkPrevProps
            preSelection={false}
            handleSelectOption={handleContractSelection}
          />
      }
    </>
  );
};

ContractForm.propTypes = componentPropTypes;

ContractForm.defaultProps = componentDefaultProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withModal(ContractForm));
export { ContractForm };
